module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('search-map')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eacc234"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/SearchMap.vue
// module id = 2318
// module chunks = 1